import {evite} from 'evite';
import './react';
import * as _ReactRouter from 'node-modules-react-router';

Object.assign(exports, _ReactRouter);
evite.assert(_ReactRouter.Route, 'Possibly using a minified version of react-router');

evite.set(evite, 'exports.ReactRouter', exports);
window.ReactRouter = exports;
